
import { updateDiagramStepWidth, getDiagramStepWidth } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepWidthProps = {
    tasks?: boolean;
    duration?: boolean;
    std_deviation?: boolean;
}

export const changeStepWidth = ({
    tasks,
    duration,
    std_deviation,
}: StepWidthProps) => updateDiagramStepWidth({
    tasks,
    duration,
    std_deviation,
});

export const getStepWidth = (): StepWidthProps => getDiagramStepWidth();
